import { watch } from "vue";

import { storage } from "~/services/storage";
import { getElement } from "~/services/dom";

import { currentIcon, currentLocation, currentServiceClass } from ".";

import type { Location } from "@/types";

interface LocationStorage {
	location: Location;
	icon: string;
	serviceClass: string;
}

const LOCATION_STORAGE_KEY = "__innosend_location";

export function currentLocationStorage(): void {
	const currentStorage = storage.get<LocationStorage>(LOCATION_STORAGE_KEY);

	watch(
		currentLocation,
		() => {
			storage.set(LOCATION_STORAGE_KEY, {
				location: currentLocation.value,
				icon: currentIcon.value,
				serviceClass: currentServiceClass.value
			});
		},
		{ deep: true }
	);

	if (currentStorage) {
		currentLocation.value = currentStorage.location;
		currentIcon.value = currentStorage.icon;
		currentServiceClass.value = currentStorage.serviceClass;

		getElement("#innosend_courier_id", document)?.setAttribute("value", currentStorage.location.id ?? "");
		getElement("#innosend_courier_name", document)?.setAttribute("value", currentStorage.serviceClass ?? "");
		getElement("#innosend_location_data", document)?.setAttribute("value", JSON.stringify(currentStorage.location));
	}
}
